import React, { Component } from 'react';
import { View, StyleSheet } from 'react-native';
import DRNImage from '../../standard/Image/DRNImage';
import DRNText from '../../standard/Text/DRNText';
import DRNButton from '../../standard/Button/DRNButton';
import DRNTouchableWrapper from '../../standard/Button/TouchableButtonWrapper';
import PropTypes from 'prop-types';
import R from '../../core-res/R';
import { withTheme } from '../../theme';
import START_COMPONENT_VARIANTS from './variants/startComponentVariants';
import MIDDLE_VIEW_VARIANTS from './variants/middleViewVariants';
class NavBar extends Component {
    constructor() {
        super(...arguments);
        this.renderCloseButton = () => {
            const { startComponentVariant, theme, onStartComponentPress } = this.props;
            const buttonByVariant = {
                [START_COMPONENT_VARIANTS.BACK_BUTTON]: (<DRNImage style={[styles.closeButton, { tintColor: theme.lightPrimary }, { transform: [{ rotateZ: '270deg' }] }]} source={require('../../../images/ic-sys-chevron-up.png')}/>),
                [START_COMPONENT_VARIANTS.CANCEL_BUTTON]: (<DRNImage style={[styles.closeButton, { tintColor: theme.lightPrimary }]} source={require('../../../images/icSysCrossClose.png')}/>),
            };
            const Button = buttonByVariant[startComponentVariant];
            return (<View style={styles.startComponent}>
        <DRNTouchableWrapper onPress={onStartComponentPress}>{Button}</DRNTouchableWrapper>
      </View>);
        };
        this.renderTextView = () => {
            const { theme, title, subtitle } = this.props;
            return (<View style={styles.middleView}>
        <DRNText style={[styles.titleText, { color: theme.lightPrimary }]} numberOfLines={1}>
          {title}
        </DRNText>
        {!!subtitle && (<DRNText style={[styles.subtitleText, { color: theme.lightSecondary }]} numberOfLines={1}>
            {subtitle}
          </DRNText>)}
      </View>);
        };
        this.renderButtonView = () => {
            const { title, onButtonPress } = this.props;
            return (<View style={styles.middleView}>
        <DRNButton text={title} variant={DRNButton.VARIANT.SECONDARY} onPress={onButtonPress}/>
      </View>);
        };
        this.renderMiddleView = () => {
            const { middleViewVariant } = this.props;
            const viewByVariant = {
                [MIDDLE_VIEW_VARIANTS.TEXT_VIEW]: () => this.renderTextView(),
                [MIDDLE_VIEW_VARIANTS.BUTTON_VIEW]: () => this.renderButtonView(),
            };
            const MiddleView = viewByVariant[middleViewVariant];
            return <MiddleView />;
        };
        this.renderEndComponent = () => {
            const { EndComponent } = this.props;
            return <View style={styles.endComponent}>{EndComponent && <EndComponent />}</View>;
        };
    }
    render() {
        const { theme } = this.props;
        return (<View style={[styles.container, { backgroundColor: theme.brand }]}>
        {this.renderCloseButton()}
        {this.renderMiddleView()}
        {this.renderEndComponent()}
      </View>);
    }
}
NavBar.propTypes = {
    theme: PropTypes.object,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    startComponentVariant: PropTypes.oneOf(Object.values(START_COMPONENT_VARIANTS)),
    onStartComponentPress: PropTypes.func.isRequired,
    middleViewVariant: PropTypes.oneOf(Object.values(MIDDLE_VIEW_VARIANTS)),
    EndComponent: PropTypes.func,
    onButtonPress: PropTypes.func,
};
NavBar.defaultProps = {
    middleViewVariant: MIDDLE_VIEW_VARIANTS.TEXT_VIEW,
};
const sizeIcon = 24;
const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingHorizontal: 2 * R.spacing.s + sizeIcon,
        paddingVertical: R.spacing.xxs,
        minHeight: 44,
    },
    titleText: Object.assign({}, R.typography.title2, { textAlign: 'center' }),
    subtitleText: Object.assign({}, R.typography.uiTiny, { textAlign: 'center' }),
    middleView: {
        flex: 1,
        alignItems: 'center',
        zIndex: -1,
    },
    startComponent: {
        position: 'absolute',
        left: R.spacing.s,
        alignItems: 'center',
        justifyContent: 'center',
    },
    endComponent: {
        position: 'absolute',
        right: R.spacing.s,
        alignItems: 'center',
        justifyContent: 'center',
    },
    closeButton: {
        width: sizeIcon,
        height: sizeIcon,
    },
});
const DRNNavBar = withTheme(NavBar);
DRNNavBar.START_COMPONENT_VARIANTS = START_COMPONENT_VARIANTS;
DRNNavBar.MIDDLE_VIEW_VARIANTS = MIDDLE_VIEW_VARIANTS;
export default DRNNavBar;
